/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLpInspectionCouponGroupDto } from '../../models/create-lp-inspection-coupon-group-dto';
import { LpInspectionCouponGroupDto } from '../../models/lp-inspection-coupon-group-dto';

export interface LpInspectionCouponGroupControllerCreate$Params {
      body: CreateLpInspectionCouponGroupDto
}

export function lpInspectionCouponGroupControllerCreate(http: HttpClient, rootUrl: string, params: LpInspectionCouponGroupControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionCouponGroupDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionCouponGroupControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionCouponGroupDto>;
    })
  );
}

lpInspectionCouponGroupControllerCreate.PATH = '/api/lp-inspection-coupon-group';
